//File Generated by Castle.
//!IMPORTANT Manual Changes to this file will be overwritten

import React, { Component } from 'react';
import {
  TextField,
  Button,
  ButtonBase,
  FormControlLabel,
  Radio,
  MenuItem,
  Link,
  DatePicker,
  FormControl,
  FormLabel,
  RadioGroup,
  CheckBox
} from '@mui/material';

export default function TertiaryButton ({
  onClick,
  value,
  children,
  ...props
}) {
  const label = children;
  return (
    <ButtonBase
      {...props}
      sx={{
        color: "rgba(0,0,0,0.87)",
        backgroundColor: "#FFF",
        opacity: 0.8,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
        borderBottomLeftRadius: 8,
        minHeight: 52,
        '&.Mui-disabled': {
          color: "rgb(102, 102, 102, .2)",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
        '&:hover, &.Mui-focusVisible': {
          zIndex:1,
          opacity: 1
        },
      }}
      onClick={onClick}
    >
      {label}
    </ButtonBase>
  )};
